import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Card, CardBody, CardFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Background from "../../common/Background";
import corner1 from "../../../assets/img/illustrations/corner-1.png";
import corner2 from "../../../assets/img/illustrations/corner-2.png";
import corner3 from "../../../assets/img/illustrations/corner-3.png";

// Cada color de tarjeta usa la ilustración de esquina que mejor le combina,
// igual que las tarjetas de saldos del resumen.
const CORNERS = {
  success: corner3,
  warning: corner1,
  danger: corner1,
  primary: corner2,
  info: corner2,
  secondary: corner2,
};

// Acceso a una vista del módulo. Toda la tarjeta es clicable (stretched-link)
// y se ve como tal: título en forma de enlace, una línea que dice para qué
// sirve la vista y, si aplica, una acción directa ("Registrar") en el pie.
const clickable = (onClick) => (event) => {
  event.preventDefault();
  onClick();
};

const HubLinkCard = ({ to, onClick, icon, color, title, description, meta, action }) => (
  <Card className="border shadow-none h-100 overflow-hidden hover-shadow" style={{ borderRadius: 12 }}>
    <Background image={CORNERS[color] || corner2} className="bg-card" />
    <CardBody className="d-flex position-relative">
      <div className={`bg-soft-${color} p-2 rounded-circle mr-3 flex-shrink-0 align-self-start`}>
        <FontAwesomeIcon icon={icon} fixedWidth className={`text-${color} fs-0`} />
      </div>
      <div className="min-w-0" style={{ flex: 1 }}>
        <div className="d-flex justify-content-between align-items-start">
          <h6 className="mb-1 mr-2">
            {onClick ? (
              <a href="#!" onClick={clickable(onClick)} className="stretched-link text-900">
                {title}
              </a>
            ) : (
              <Link to={to} className="stretched-link text-900">
                {title}
              </Link>
            )}
          </h6>
          {meta}
        </div>
        <p className="fs--1 text-600 mb-0">{description}</p>
      </div>
    </CardBody>
    {action && (
      <CardFooter className="bg-light py-2">
        {/* Por encima del stretched-link para que el clic no abra la vista. */}
        <Link
          to={action.to}
          className="fs--1 font-weight-semi-bold position-relative"
          style={{ zIndex: 2 }}
        >
          <FontAwesomeIcon icon={faPlus} className="mr-1" />
          {action.label}
        </Link>
      </CardFooter>
    )}
  </Card>
);

const linkTarget = PropTypes.oneOfType([PropTypes.string, PropTypes.object]);

HubLinkCard.propTypes = {
  to: linkTarget,
  onClick: PropTypes.func,
  icon: PropTypes.object.isRequired,
  color: PropTypes.string,
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  meta: PropTypes.node,
  action: PropTypes.shape({ to: linkTarget.isRequired, label: PropTypes.string.isRequired }),
};

HubLinkCard.defaultProps = { color: "primary" };

export default HubLinkCard;
